module.exports = __webpack_public_path__ + "static/milestone2-1519f58eb4c22e188671af6e1e9819b5.png";